// import axios from "axios";
import { APP_ERROR, SET_APP_LOADING } from "./types";

export const setAppLoading = (loading) => async (dispatch) => {
    try {
        dispatch({
            type: SET_APP_LOADING,
            payload: loading,
        });
    } catch (error) {
        dispatch({
            type: APP_ERROR,
            payload: error,
        });
    }
};
